import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import PlanetLinks from '../../../components/PlanetLinks/PlanetLinks';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Retro.scss'



const Retro = () => {
    return(
        <div className="Retro-container">
            <InnerNav/>
            <div className="Retro-content">
                <Zodiac/>

                <div className="planet-header">
                    <h3>Planets Retrograde</h3>
                </div>

                <div className="planet-grid">
                    <div className="planet-card">
                       <img src="https://cdn.britannica.com/64/73464-050-56C80D3A/view-composite-images-Mars-spacecraft-Global-Surveyor-April-1999.jpg?w=200&h=200&c=crop" alt="" />
                        <p>Mangal Vakri</p>
                    </div>

                     <div className="planet-card">
                        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Mercury_in_color_-_Prockter07-edit1.jpg/330px-Mercury_in_color_-_Prockter07-edit1.jpg" alt="" />
                        <p>Budha Vakri</p>
                    </div>

                     <div className="planet-card">
                        <img src="https://upload.wikimedia.org/wikipedia/commons/e/e2/Jupiter_OPAL_2024.png" alt="" />
                        <p>Guru Vakri</p>
                    </div>

                     <div className="planet-card">
                        <img src="https://static.toiimg.com/thumb/msid-111581483,width-1280,height-720,resizemode-4/111581483.jpg" alt="" />
                        <p>Shukra Vakri</p>
                    </div>

                     <div className="planet-card">
                        <img src="https://upload.wikimedia.org/wikipedia/commons/c/c7/Saturn_during_Equinox.jpg" alt="" />
                        <p>Shani Vakri</p>
                    </div>

                     <div className="planet-card">
                        <img src="https://upload.wikimedia.org/wikipedia/commons/3/3d/Uranus2.jpg" alt="" />
                        <p>Arun Vakri</p>
                    </div>

                    <div className="planet-card">
                        <img src="https://cdn.mos.cms.futurecdn.net/PezBzd9Fehsq9XWgWMauVV.jpg" alt="" />
                        <p>Varun Vakri</p>
                    </div>

                    <div className="planet-card">
                        <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpur0AGLTrDBtaLQ-hmBlJ07w9vwkZOmgckQ&s" alt="" />
                        <p>Yama Vakri</p>
                    </div>
                </div>
                <PlanetLinks/>
            </div>
            <Footer/>
        </div>
    )
}
export default Retro;